export default "__VITE_ASSET__DkDz$UlQ__"